/**
 * @group Constants

@summary
<blockquote>Available log levels</blockquote>

@example
```typescript
const level = LOG_LEVELS.INFO;
```
 * @internal
 */
export const LOG_LEVELS = {
  NONE: 'none',
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
} as const; 